import { DataBoxTable } from '../../../../Components/DataBoxTable/DataBoxTable';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getMetrics, updateMetrics } from '../../../../Services/Jobs';
import { fieldsContactSource, metricsFields } from '../../../../Utils/fields';
import { Loader } from '../../../../Components/Loader/Loader';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { t as tGlobal } from 'i18next';

export const JobMetrics = ({ jobId }: { jobId: string }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [onMetricsEdit, setOnMetricsEdit] = useState(false);

  const { data: jobMetricsData, isLoading } = useQuery({
    queryKey: ['getMetrics', jobId],
    queryFn: () => getMetrics(jobId!),
    enabled: !!jobId,
  });

  const {
    control: metricsControl,
    handleSubmit: handleMetricsSubmit,
    formState: { errors: metricsErrors },
    reset: resetMetrics,
  } = useForm();

  useEffect(() => {
    if (jobMetricsData) {
      resetMetrics(jobMetricsData);
    }
  }, [jobMetricsData, resetMetrics]);

  const { mutate: updateMetricsMutation } = useMutation({
    mutationFn: (data: Partial<JobMetricsType>) => updateMetrics(jobId, data),
    onSuccess: () => {
      toast.success(tGlobal('toast.success.edit', { elem: 'Metrics' }));
      queryClient.invalidateQueries({ queryKey: ['getMetrics', jobId] });
    },
    onError: () => {
      toast.error(tGlobal('toast.errors.something_went_wrong'));
    },
  });

  const onSubmitMetrics = (data: any) => {
    updateMetricsMutation({ totalContactedCandidates: data.totalContactedCandidates });
    setOnMetricsEdit(false);
  };

  return (
    <div style={{ display: 'flex' }}>
      {<Loader isLoading={isLoading} />}
      {jobMetricsData && (
        <>
          <DataBoxTable
            title={t('jobs.metrics.job_metrics')}
            fields={metricsFields}
            values={jobMetricsData}
            onEdit={onMetricsEdit}
            handleEdit={() => setOnMetricsEdit(true)}
            handleCancel={() => {
              setOnMetricsEdit(false);
              resetMetrics(jobMetricsData);
            }}
            handleSave={() => handleMetricsSubmit(onSubmitMetrics)()}
            control={metricsControl}
            errors={metricsErrors}
          />
          <DataBoxTable
            title={t('jobs.metrics.candidate_source')}
            fields={fieldsContactSource}
            values={jobMetricsData.candidateSourceCounts}
          />
        </>
      )}
    </div>
  );
};
